import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../components-styles/CookieConsent.css';

function CookieConsent() {
  const [showCookieBanner, setShowCookieBanner] = useState(false);

  useEffect(() => {
    // Show cookie banner on every page load/visit
    // Display after a short delay for better UX
    const timer = setTimeout(() => {
      setShowCookieBanner(true);
      console.log('Displaying cookie consent banner');
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  const handleAcceptAll = () => {
    console.log('User accepted all cookies');
    localStorage.setItem('cookieConsent', 'accepted-all');
    localStorage.setItem('analyticalCookies', 'true');
    localStorage.setItem('marketingCookies', 'true');
    localStorage.setItem('cookieConsentTimestamp', new Date().toISOString());
    setShowCookieBanner(false);
  };

  const handleAcceptEssential = () => {
    console.log('User accepted essential cookies only');
    localStorage.setItem('cookieConsent', 'essential-only');
    localStorage.setItem('analyticalCookies', 'false');
    localStorage.setItem('marketingCookies', 'false');
    localStorage.setItem('cookieConsentTimestamp', new Date().toISOString());
    setShowCookieBanner(false);
  };

  const handleReject = () => {
    console.log('User rejected non-essential cookies');
    localStorage.setItem('cookieConsent', 'rejected');
    localStorage.setItem('analyticalCookies', 'false');
    localStorage.setItem('marketingCookies', 'false');
    localStorage.setItem('cookieConsentTimestamp', new Date().toISOString());
    setShowCookieBanner(false);
  };

  if (!showCookieBanner) return null;

  return (
    <div className="cookie-consent-banner">
      <div className="cookie-consent-container">
        <div className="cookie-consent-content">
          <div className="cookie-consent-text">
            <h3>🍪 Cookie Consent</h3>
            <p>
              We use cookies to enhance your browsing experience, analyze site traffic, and serve targeted ads. 
              By clicking "Accept All", you consent to our use of cookies. You can manage your preferences or 
              learn more in our{' '}
              <Link to="/privacy-policy" className="cookie-link">
                Privacy Policy
              </Link>
              {' '}and{' '}
              <Link to="/terms-and-conditions" className="cookie-link">
                Terms & Conditions
              </Link>
              .
            </p>
          </div>
          <div className="cookie-consent-buttons">
            <button 
              className="cookie-btn cookie-btn-reject"
              onClick={handleReject}
              aria-label="Reject non-essential cookies"
            >
              Reject
            </button>
            <button 
              className="cookie-btn cookie-btn-essential"
              onClick={handleAcceptEssential}
              aria-label="Accept essential cookies only"
            >
              Essential Only
            </button>
            <button 
              className="cookie-btn cookie-btn-accept"
              onClick={handleAcceptAll}
              aria-label="Accept all cookies"
            >
              Accept All
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CookieConsent;
